module.exports = __webpack_public_path__ + "static/media/paypal.3662fa34.svg";